import {buildStyles, CircularProgressbar} from "react-circular-progressbar";
import {FaRegCircleCheck} from "react-icons/fa6";


export default function ScoreProgressCard({className, value, title, color, total, suggestions, ...props}) {
    let myValue = (value / total) * 100;
    myValue = Math.round(myValue)
    if (!value)
        return null
    return (
        <div
            className={"flex flex-col w-full border-[1px] p-[24px] border-[#98A2B3] rounded-md bg-white shadow-md lg:rounded-[32px] shadow-[#0000001F] gap-4 justify-center  items-center"}>
            <div className={"flex flex-col gap-2"}>
                <div className={"flex flex-col justify-center items-center gap-2 mx-auto"}>
                    <div className={" w-[80px] h-[80px] lg:w-[100px] lg:h-[100px]"}>
                        <CircularProgressbar
                            value={myValue}
                            text={value + ""}
                            styles={buildStyles({
                                pathColor: color,
                                textColor: color,
                            })}
                        />
                    </div>
                    <p className={"text-[20px] font-semibold text-gray-700 "}>{title}</p>
                </div>

                <div className={"w-full"}>
                    <p className={"font-[500] text-[20px]"}>
                        Suggested Changes to Improve Your Score
                    </p>
                    <div className={"mt-[20px] flex flex-col gap-[20px]"}>
                        {
                            suggestions?.map((suggestion, i) => {
                                return (
                                    <div key={i} className={"flex flex-row gap-2 items-center"}>
                                        <div className={"w-[28px] h-[28px]"}>
                                        <FaRegCircleCheck className={"!text-[20px]"} />

                                        </div>
                                        <p className={'text-[16px] text-[#001225]'}>
                                            {suggestion}
                                        </p>
                                    </div>
                                )
                            })
                        }

                    </div>
                </div>
            </div>
        </div>
    )
}